import { FormattedMessage as FM, useIntl } from "react-intl";
import { useState, Fragment, useEffect } from "react";

import RestCategories from "./RestCategories";
import RestProducts from "./RestProducts";
import IconButton from "components/Buttons/IconButton";
import { useStoreRest } from "../storeRest";
import { XMarkIcon, SearchIcon } from "components/Icons";
import SelectField from "./select";

function MenuRest({ record, onClose }) {
  const [shopId, setShopId] = useState(record?.shop?.id ?? record?.shop);
  const [query, setQuery] = useState("");

  const shop = useStoreRest((state) => state.shops[shopId]);
  const shopAccess = useStoreRest((state) => state.shopAccess);
  const gotoCategory = useStoreRest((state) => state.gotoCategory);
  const initShop = useStoreRest((state) => state.initShop);
  const searchProducts = useStoreRest((state) => state.searchProducts);
  const [view, setView] = useState("categories");
  const [message, setMessage] = useState(null);
  const [category, setCategory] = useState(null);

  const { currentCats, catsIndex } = shop;
  const searchResults = useStoreRest(
    (state) => state.shops[shopId]?.searchResults,
  );
  const searchQuery = useStoreRest(
    (state) => state.shops[shopId]?.searchQuery,
  );
  const intl = useIntl();

  const optionsShop =
    shopAccess?.map((shop) => ({
      label: shop.name,
      value: shop.id,
    })) || [];

  useEffect(() => {
    if (!query.trim()) return;
    const timer = setTimeout(() => {
      searchProducts(shopId, query);
    }, 300);
    return () => clearTimeout(timer);
  }, [query, shopId]);

  const isSearching = query.trim().length > 0;
  const resultsReady =
    isSearching && searchQuery === query.trim().toLowerCase();

  async function onChange(action, item) {
    setMessage(null);
    if (action === "back") {
      await gotoCategory(shopId);
      setView("categories");
    } else {
      await gotoCategory(shopId, item.id);
      setCategory(item);
      if (item.childs) {
        setView("categories");
      } else {
        setView("products");
      }
    }
  }

  async function onChangeShop(e) {
    let shop = e.target.value;
    shop = Number(shop);
    await initShop(shop);
    await gotoCategory(shop);
    setShopId(shop);
    setQuery("");
    setView("categories");
  }

  function onChangeQuery(e) {
    setQuery(e.target.value);
  }

  function clearSearch() {
    setQuery("");
  }

  return (
    <div>
      <div className="-z-auto flex p-4 mb-4 ml-auto my-auto  text-zinc-700 rounded-t-md">
        <div
          className={
            "!my-auto font-bold leading-6 mb-2 text-lg md:text-xl lg:text-3xl"
          }
        >
          <FM id={"sale.sale.see_menu"} /> |
        </div>

        <SelectField
          name="shop"
          options={optionsShop}
          value={shopId || ""}
          onChange={onChangeShop}
          className={
            "bg-transparent text-lg font-semibold text-zinc-700 border-none focus:outline-none rounded-md"
          }
        />
        <XMarkIcon
          onClick={onClose}
          className="ml-auto h-7 w-7 fill-zinc-700 cursor-pointer hover:fill-rose-700"
        />
      </div>
      <div className="relative px-4 mb-2">
        <input
          type="text"
          value={query}
          onChange={onChangeQuery}
          placeholder={intl.formatMessage({
            id: "rest_order.search_products",
            defaultMessage: "Buscar producto...",
          })}
          className="w-full h-10 pl-9 pr-8 rounded-lg border border-gray-200 bg-white shadow-sm text-sm text-neutral-800 placeholder:text-neutral-400 focus:border-cyan-500 focus:outline-none"
        />
        <SearchIcon className="absolute left-6 top-1/2 -translate-y-1/2 h-4 w-4 fill-neutral-400 pointer-events-none" />
        {isSearching && (
          <XMarkIcon
            onClick={clearSearch}
            className="absolute right-5 top-1/2 -translate-y-1/2 h-4 w-4 fill-neutral-400 cursor-pointer hover:fill-rose-600"
          />
        )}
      </div>
      <div id="modal-menu-rest-order" className="p-4 ml-auto my-auto ">
        {catsIndex.length > 0 && !isSearching && (
          <IconButton
            onClick={() => onChange("back")}
            color="stone"
            name="button_back"
            tooltip="board.button_back"
          />
        )}

        {isSearching ? (
          <Fragment>
            {resultsReady ? (
              searchResults && searchResults.size > 0 ? (
                <RestProducts
                  products={searchResults}
                  shopId={shopId}
                  updateMsg={setMessage}
                />
              ) : (
                <div className="flex text-zinc-400 mx-auto my-auto font-semibold py-6 justify-center">
                  <FM
                    id="rest_order.no_results"
                    defaultMessage="Sin resultados"
                    key="rest_order.no_results"
                  />
                </div>
              )
            ) : (
              <div className="h-16" />
            )}
          </Fragment>
        ) : view === "categories" ? (
          <RestCategories onChange={onChange} visibleCats={currentCats} />
        ) : (
          <Fragment>
            <div className="flex">
              {message && (
                <div className="flex text-sky-700 mx-auto my-auto font-bold gap-x-3">
                  {message}
                  <i
                    key="check"
                    className="flex text-lime-500 text-2xl text-bold my-auto fi fi-br-check"
                  />
                </div>
              )}
            </div>
            <RestProducts
              categoryId={category.id}
              shopId={shopId}
              updateMsg={setMessage}
            />
          </Fragment>
        )}
      </div>
    </div>
  );
}

export default MenuRest;
